import React, { useContext } from "react"
import { Button, Text } from "@chakra-ui/react"
import { handleMenuLinkClick } from "../../../handlers"
import { FormContext } from "../../../contexts"
import { Icon } from "../../"

export default function PackageButton({ name }) {
  const { updateSubject } = useContext(FormContext)

  const handleClick = evt => {
    updateSubject(`Enquiry regarding ${name}`)
    handleMenuLinkClick("/#contact", evt)
  }

  return (
    <Button
      onClick={evt => handleClick(evt)}
      alignSelf="center"
      variant="primary"
      size="lg"
      mt="auto"
    >
      <Text as="span" lineHeight={1}>
        Select
      </Text>
      <Icon name="arrowRight" boxSize={5} ml={3} />
    </Button>
  )
}
